// extracted by mini-css-extract-plugin
export default {"coordinate":"MapPointModal_coordinate__kdf3e","pointForm":"MapPointModal_pointForm__Lh00V","pointModal":"MapPointModal_pointModal__Jk9yO"};